import { createServerFn } from "@tanstack/react-start";
import { readCart, readOrderPage, readProduct, readShop, readShopCollection } from "./shop.server";
import { siteContext } from "./site.server";

// An address that can't be a slug names nothing: the page is missing, as on the Astro site, rather
// than failing.
const slugInput = (input: unknown) =>
  typeof input === "string" && input.length <= 200 ? input : "";

/** Merch (/merch) in one request: the page the creator composed, or the native listing. */
export const loadShop = createServerFn({ method: "GET" })
  .validator((input: unknown) => input === true)
  .handler(async ({ data: native, context }) => readShop(await siteContext(context), native));

/** One product (/merch/products/:slug), from the public listing. */
export const loadProduct = createServerFn({ method: "GET" })
  .validator(slugInput)
  .handler(async ({ data: slug, context }) => readProduct(await siteContext(context), slug));

/** One merch collection (/merch/collections/:slug). */
export const loadShopCollection = createServerFn({ method: "GET" })
  .validator(slugInput)
  .handler(async ({ data: slug, context }) => readShopCollection(await siteContext(context), slug));

/** The bag (/merch/cart): delivery countries and purchase readiness, never the bag itself. */
export const loadCart = createServerFn({ method: "GET" }).handler(async ({ context }) =>
  readCart(await siteContext(context)),
);

/** Checkout (/merch/checkout) or an order (/merch/orders/:id): the page, never the order. */
export const loadOrderPage = createServerFn({ method: "GET" })
  .validator((input: unknown) => (input === "checkout" ? "checkout" : "order"))
  .handler(async ({ data: page, context }) => readOrderPage(await siteContext(context), page));
